export default "__VITE_ASSET__4540eb0f__"